/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError } from '.';
import CommonApi from '../Api/CommonApi';
import ClientApi from '../Api/ClientApi';
import VendorApi from '../Api/VendorApi';

export const fetchStates = createAsyncThunk(
  'FETCH_STATES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getStates();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchCountries = createAsyncThunk(
  'FETCH_COUNTRIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getCountries();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchUserLevels = createAsyncThunk(
  'FETCH_USER_LEVELS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getUserLevels();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchPageTypes = createAsyncThunk(
  'FETCH_PAGE_TYPES',
  async (_, thunkApi) => {
    // const { pageTypes } = useAppSelector((state))
    try {
      const response = await CommonApi.getPageTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchIndustries = createAsyncThunk(
  'FETCH_INDUSTRIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getIndustries();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchFileTypes = createAsyncThunk(
  'FETCH_FILETYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getFileTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchSubscriptions = createAsyncThunk(
  'FETCH_SUBSCRIPTIONS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getSubscriptions();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchCustomOptions = createAsyncThunk(
  'FETCH_CUSTOMOPTIONS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getCustomOptions();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchExistingEmails = createAsyncThunk(
  'FETCH_EXISTINGEMAILS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getExistingEmails();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchClientTypes = createAsyncThunk(
  'FETCH_CLIENTTYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getClientTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchMarketSegments = createAsyncThunk(
  'FETCH_MARKETSEGMENTS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getMarketSegments();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchMarketSubSegments = createAsyncThunk(
  'FETCH_MARKETSUBSEGMENTS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getMarketSubSegments();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchClientLocations = createAsyncThunk(
  'FETCH_CLIENTLOCATIONS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getClientLocations();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchManufacturers = createAsyncThunk(
  'FETCH_MANUFACTURERS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getManufacturers();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchCategories = createAsyncThunk(
  'FETCH_CATEGORIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getCategories();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchSubCategories = createAsyncThunk(
  'FETCH_SUBCATEGORIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getSubCategories();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);

export const fetchClients = createAsyncThunk(
  'FETCH_CLIENTS',
  async (_, thunkApi) => {
    try {
      const response = await ClientApi.getClientsList();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchLocationTypes = createAsyncThunk(
  'FETCH_LOCATIONTYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getLocationTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchUsers = createAsyncThunk(
  'FETCH_USERS',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getUsers();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchInventoryTypes = createAsyncThunk(
  'FETCH_INVENTORYTYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getInventoryTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchEquipmentTypes = createAsyncThunk(
  'FETCH_EQUIPMENTTYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getEquipmentTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchVendors = createAsyncThunk(
  'FETCH_VENDORS',
  async (_, thunkApi) => {
    try {
      const response = await VendorApi.getVendorsList();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchClientsWithLocationList = createAsyncThunk(
  'FETCH_CLIENTS_WITH_LOCATION',
  async (_, thunkApi) => {
    try {
      const response = await ClientApi.getClientsWithLocationList();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchFrequencies = createAsyncThunk(
  'FETCH_FREQUENCIES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getFrequencies();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchAssetStatuses = createAsyncThunk(
  'FETCH_ASSET_STATUSES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getAssetStatuses();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
export const fetchAssetTypes = createAsyncThunk(
  'FETCH_ASSET_TYPES',
  async (_, thunkApi) => {
    try {
      const response = await CommonApi.getAssetTypes();
      return response.data;
    } catch (error) {
      const { errorMessage } = handleError(error);
      return thunkApi.rejectWithValue(errorMessage);
    }
  }
);
